 import React from 'react';

 import {SpinnerContainer, SpinnerOverlay,SpinnerContainerSmall,SpinnerOverlaySmall} from './spinner.styles';

 const Spinner = ({size}) => (
     !!size===false ?   <SpinnerOverlay>
         <SpinnerContainer />
     </SpinnerOverlay>  :   <SpinnerOverlaySmall><SpinnerContainerSmall /></SpinnerOverlaySmall>
 );
 
 export default Spinner;